module.exports = "//static.hsappstatic.net/connect-dot-com-public-ui/static-1.1195/images/homepageCardImages/academy-bg.svg"